import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { key: 0 }

import { computed } from "vue";
import { FinishInfoResponse } from '@/guiide/ts/response/finishInfoResponse';
import Constants from "@/guiide/ts/constants";
import { formatter } from "@/shared/ts/formatter";
import { useStore } from "vuex";
import SubSection from "../common/SubSection.vue";

type Model = { extraCharge: number, additionalMessage: string, displayConsolidationMessage: boolean };


export default /*@__PURE__*/_defineComponent({
  __name: 'EffectOfHigherCharges',
  props: {
    finishInfo: {
        type: Object as () => FinishInfoResponse,
        default: () => new FinishInfoResponse(false, 0, []),
    },
},
  setup(__props) {

const props = __props;

const store = useStore();
const display = computed<boolean>(() => store.state.configuration.finishDisplaysCharges);
const industryAvgCharge = computed<number>(() => props.finishInfo?.getIndustryAverageChargeResponse().charge ?? 0);

const model = computed<Model>(() => {
    const costAtOnePointFive = industryAvgCharge.value;
    const costAtOnePointSix = (1.6 / 1.5) * costAtOnePointFive;
    const diff = costAtOnePointSix - costAtOnePointFive;
    const extraCharge = Math.ceil(diff / Constants.IncomeStepSize) * Constants.IncomeStepSize;

    const additionalMessage = store.state.configuration.finishDisplaysChargesExtraMessage;
    const displayConsolidationMessage = store.state.configuration.finishDisplaysChargesShowsPotCnsldnMsg;
    return { extraCharge, additionalMessage, displayConsolidationMessage };
});


return (_ctx: any,_cache: any) => {
  return (display.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SubSection, {
            title: "Effect of higher charges",
            showHelp: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, [
                _cache[0] || (_cache[0] = _createTextVNode(" A difference of 0.1% a year in charges seems very little. But for every 0.1% a year you pay in extra charges, this amounts to a total of ")),
                _createElementVNode("strong", null, _toDisplayString(_unref(formatter).formatCurrency(model.value.extraCharge)), 1),
                _createTextVNode(" more in charges over the expected lifetime of your plan. This will be coming out of your pots if you don't get any additional growth from paying the extra charges. " + _toDisplayString(model.value.additionalMessage) + " ", 1),
                (model.value.displayConsolidationMessage)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_3, " Putting all your pots together with a low cost provider may save you 5 times this amount (compared to paying total average charges of around 1%). "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})